import { shape, string, number, bool, arrayOf } from 'prop-types';

export const payElement = shape({
  targetElement: string,
  currentYear: shape({
    label: number,
    value: number
  }),
  prevYear: shape({
    label: number,
    value: number
  }),
  prevPrevYear: shape({
    label: number,
    value: number
  })
});

export const surveyJobMatch = shape({
  baseSalary: payElement,
  totalCash: payElement,
  totalTargetCash: payElement,
  totalDirect: payElement,
  totalGuaranteedPay: payElement,
  monetaryRounding: number,
  percentRounding: number,
  metadata: shape({
    surveyJobCode: string,
    surveyCode: string,
    jobScope: string,
    benchmarkYear: number,
    surveyTitle: string
  })
});

export const surveyJobMatches = arrayOf(surveyJobMatch);

export const overallComposite = shape({
  data: shape({
    baseSalary: payElement,
    totalCash: payElement,
    totalTargetCash: payElement,
    totalDirect: payElement,
    totalGuaranteedPay: payElement,
    monetaryRounding: number,
    percentRounding: number,
    metadata: shape({
      isAllNull: bool,
      onlyOneYearData: bool,
      onlyDataLabel: string
    })
  })
});
